<mat-tab-group class="main-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true" [(selectedIndex)]="selectedTabIndex">

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">badge</mat-icon>
            <span class="tab-label-text">Dados Gerais</span>
            @if (isAbaInvalida('nome', 'classificacao', 'observacao', 'informacaoFisco')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-dados-gerais-tab
            [form]="form"
            [modelos]="modelosDocumento"
            [csts]="csts"
            [cclasstribs]="cclasstribs"
            [relacoes]="relacoes"
            [isModoPadrao]="isModoPadrao"
            [indicadoresDoacao]="indicadoresDoacao"
            [formulas]="formulasRegra">
        </app-regra-tributaria-dados-gerais-tab>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">hub</mat-icon>
            <span class="tab-label-text">IBS/CBS</span>
            @if (isAbaInvalida('ibsCbs')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-ibs-cbs-tab
            [form]="form"
            [isModoPadrao]="isModoPadrao"
            [indicadoresUi]="indicadoresUi"
            [formulasIbsCbs]="formulasIbsCbs"
            [formulasCbs]="formulasCbs"
            [formulasIbsUf]="formulasIbsUf"
            [formulasIbsMunicipio]="formulasIbsMunicipio">
        </app-regra-tributaria-ibs-cbs-tab>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">rule</mat-icon>
            <span class="tab-label-text">Tributação Regular</span>
            @if (isAbaInvalida('tributacaoRegular')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-trib-regular-tab
            [form]="form"
            [csts]="csts"
            [cclasstribs]="cclasstribs"
            [formulas]="formulasTribRegular">
        </app-regra-tributaria-trib-regular-tab>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">local_gas_station</mat-icon>
            <span class="tab-label-text">Tributação Monofásica</span>
            @if (isAbaInvalida('mono')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-trib-mono-tab
            [form]="form"
            [formulas]="formulasMonoPadrao"
            [formulasRetencao]="formulasMonoRetencao"
            [formulasRetida]="formulasMonoRetida"
            [formulasDiferimento]="formulasMonoDiferimento">
        </app-regra-tributaria-trib-mono-tab>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">redeem</mat-icon>
            <span class="tab-label-text">Crédito Presumido</span>
            @if (isAbaInvalida('creditoPresumido')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-credito-presumido-tab
            [form]="form"
            [formulasOperacao]="formulasCreditoPresumidoOperacao"
            [formulasIbs]="formulasCreditoPresumidoIbs"
            [formulasCbs]="formulasCreditoPresumidoCbs"
            [codigosCreditoPresumido]="codigosCreditoPresumido">
        </app-regra-tributaria-credito-presumido-tab>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="material-symbols-outlined tab-icon">bolt</mat-icon>
            <span class="tab-label-text">Imposto Seletivo</span>
            @if (isAbaInvalida('impostoSeletivo')) {
            <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
        </ng-template>
        <app-regra-tributaria-is-tab [form]="form"></app-regra-tributaria-is-tab>
    </mat-tab>

</mat-tab-group>
